import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { alliancesManager, type IAlliance } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const ALLIANCE_MODULE = 'alliance';

const dataObjectModule = getDataObjectsModule<IAlliance>(alliancesManager, 3);
const searchModule = getSearchModule<IAlliance>(alliancesManager);

const allianceModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(ALLIANCE_MODULE, allianceModuleInstance);

export { ALLIANCE_MODULE };
